module.exports = __webpack_public_path__ + "img/itembg.39c10c94.png";